import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { IManageProductRow, ISavePH } from '../interfaces/manage-product.interface';
import { getRequest, HandlerResponse, postRequest, putRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetManageProductData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/manageproduct/display/manageproductscreen${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const SavePHList = async (payload: ISavePH[], queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/saveph${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateActive = async (payload: {rows: IManageProductRow[]}, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/updateskuflag${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateActiveAll = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/update/active/all${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UnassignActiveAll = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/update/unactive/all${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const InitialiseActive = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/initialize/active${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const InitialiseActiveAndRRView = async (payload: {rows: IManageProductRow[]}, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/manageproduct/AssignAndInitializeRunRateView${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const AssignPhToSku = async (payload: {phCode: string, skuCode: string}[], queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/manageproduct/assign/phtosku/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetManageProductList = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/manageproduct/assing/phtosku/screen${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const CopyWeightAndActiveStatus = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/manageproduct/copyWeightAndActiveStatus${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};
